import { object, string, ref } from 'yup';
import { ResetPasswordFormType } from './types';
import { REGEXP_PASSWORD } from '../../../utils/validations';
import i18n from '../../../i18n';

export const ResetPasswordFormSchema = object<ResetPasswordFormType>({
  newPassword: string().matches(REGEXP_PASSWORD, () =>
    i18n.t('validation:password.format')
  ),
  repeatPassword: string()
    .matches(REGEXP_PASSWORD, () => i18n.t('validation:password.format'))
    .oneOf([ref('newPassword')], () => i18n.t('validation:password.match')),
});
